module.exports = __webpack_public_path__ + "images/d6080e08046e2e2df87fdc1c8744dca1.svg";